<template>
    <v-card class="mt-3">
        <v-card-title class="text-h6 primary white--text">{{ title }}</v-card-title>
        <v-card-text>
            <div
                v-for="(account, index) in accountOverviewAbles"
                :key="index">
                <div v-if="account.accountsOverviewValue > 0" style="display: flex; justify-content: space-between">
                    <AccountNameModal :title="account.company_name" :account="account" :thisKey="index" @updateName="updateName" style="width: 33%;">
                        <template v-slot:modal-trigger>
                            <a>{{ account.company_name ? account.company_name : 'NO NAME' }}</a>
                        </template>
                    </AccountNameModal>
                    <AccountOverviewModal :title="title" style="width: 33%;">
                        <template v-slot:modal-trigger>
                            <a>{{ account.accountsOverviewName }}</a>
                        </template>
                        <template v-slot:modal-content>
                            <slot
                                name="account-detail"
                                :account="account"></slot>
                        </template>
                    </AccountOverviewModal>
                    <div style="width: 33%">{{ account.accountsOverviewValue | money }}</div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import AccountOverviewModal from "@/components/dashboard/AccountOverviewModal";
import AccountNameModal from "@/components/dashboard/AccountNameModal";
export default {
    components: {
        AccountOverviewModal,
        AccountNameModal
    },
    props: {
        accountOverviewAbles: {
            type: Array,
            required: false
        },
        title: {
            type: String,
            required: true
        }
    },
    methods: {
        updateName (value) {
            this.accountOverviewAbles[value.index].company_name = value.company_name;
        }
    }
}
</script>

